import type { AdmissionOfficeCountry } from "../../admissionOfficeCountry";
import {
  templatesUkraineEnRequestPVCoursesSettings,
  templatesUkraineEnRequestUniversityCoursesSettings,
} from "@/src/constants/AdmissionOffice/Ukraine/AOPUkraineEnConsts";

/** Extend when Request Letter exists for other countries. */
export type RequestLetterBasicCountry = Extract<AdmissionOfficeCountry, "ukraine">;

export type RequestLetterBasicRegistryEntry = {
  pvTemplates: typeof templatesUkraineEnRequestPVCoursesSettings;
  universityTemplates: typeof templatesUkraineEnRequestUniversityCoursesSettings;
};

export const REQUEST_LETTER_BASIC_REGISTRY: Record<RequestLetterBasicCountry, RequestLetterBasicRegistryEntry> = {
  ukraine: {
    pvTemplates: templatesUkraineEnRequestPVCoursesSettings,
    universityTemplates: templatesUkraineEnRequestUniversityCoursesSettings,
  },
};
